module.exports = __webpack_public_path__ + "static/media/1_pl.e5b2fd54.png";